import { Box } from "@material-ui/core";
import CloudDownload from "@material-ui/icons/CloudDownload";
import { ContainerPage, Button, TitlePage } from "components";
import { usePopup } from "hooks/usePopup";
import { useTableParams } from "hooks/useTableParams";
import fileDownload from "js-file-download";
import React, { useCallback } from "react";
import reporterGenerateService from "services/reporterGenerateService";
import storageService from "services/storageService";
import { Table } from "shared";
import { mapType } from "utils";

export default function SummaryFisic() {
  const { data, onChange, params, refresh, status, handleSearch } =
    useTableParams({
      service: params =>
        storageService.getStorageResume({ ...params, physicalStorage: true })
    });

  const { addPopup } = usePopup();

  const columns = [
    {
      field: "product_base_name",
      label: "Produto Base",
      style: { minWidth: "170px", maxWidth: "300px" }
    },
    {
      field: "product_base_id",
      label: "ID do Produto",
      align: "center",
      style: { minWidth: "140px" }
    },
    {
      field: "input_type_id",
      label: "Tipo de entrada",
      align: "center",
      style: { minWidth: "200px" },
      formatter: value => mapType(value)
    },
    {
      field: "summary",
      label: "Estoque",
      align: "center",
      style: { minWidth: "200px" },
      formatter: value => {
        if (!value) return 0;
        return new Intl.NumberFormat("pt-BR").format(value.toFixed(2));
      },
      cellStyle: data => {
        if (data.summary < 0) {
          return {
            color: "red"
          };
        }
      }
    }
  ];

  const handleDownloadSummaryFisic = useCallback(async () => {
    try {
      const dataToDownload = data?.reduce((acc, row) => {
        delete row.id;
        acc.push(row);
        return acc;
      }, []);
      const { data: downloadData } =
        await reporterGenerateService.excelGenerate(dataToDownload);

      fileDownload(downloadData, "Dados_do_estoque_fisico.xlsx");
    } catch (err) {
      if (err?.response?.status !== 401) {
        addPopup({
          type: "error",
          description: "Erro ao fazer download"
        });
      }
    }
  }, [data, addPopup]);

  return (
    <>
      <ContainerPage>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <TitlePage>Estoque Físico</TitlePage>

          <Button
            startIcon={<CloudDownload />}
            variant="contained"
            onClick={() => handleDownloadSummaryFisic()}
          >
            Download Estoque
          </Button>
        </Box>

        <Table
          handleSearch={handleSearch}
          columns={columns}
          data={data}
          onChange={onChange}
          params={params}
          size="small"
          status={status}
          refresh={refresh}
          count={data?.length}
          hover
          paginationServer={false}
          placeholder="Produto base ou ID"
        />
      </ContainerPage>
    </>
  );
}
